import * as React from "react";
const SvgThreeStars = ({ title, titleId, ...props }) => (
  <svg
    width="1em"
    height="1em"
    viewBox="0 0 22 22"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    aria-labelledby={titleId}
    {...props}
  >
    {title ? <title id={titleId}>{title}</title> : null}
    <path
      d="M16 4s.276 2.575 1.35 3.65C18.425 8.724 21 9 21 9s-2.575.276-3.65 1.35C16.276 11.425 16 14 16 14s-.276-2.575-1.35-3.65C13.575 9.277 11 9 11 9s2.575-.276 3.65-1.35C15.723 6.575 16 4 16 4ZM9 13s.22 2.06 1.08 2.92C10.94 16.78 13 17 13 17s-2.06.22-2.92 1.08C9.22 18.94 9 21 9 21s-.22-2.06-1.08-2.92C7.06 17.22 5 17 5 17s2.06-.22 2.92-1.08C8.78 15.06 9 13 9 13ZM5 1s.22 2.06 1.08 2.92C6.94 4.78 9 5 9 5s-2.06.22-2.92 1.08C5.22 6.94 5 9 5 9s-.22-2.06-1.08-2.92C3.06 5.22 1 5 1 5s2.06-.22 2.92-1.08C4.78 3.06 5 1 5 1Z"
      stroke="#8559EC"
      strokeWidth={1.5}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
export default SvgThreeStars;
